module.exports = __webpack_public_path__ + "img/ajuda-card-05.3191010a.png";